import heroImg from "../../assets/hero-building.png";

export const homeHeroContent = {
    welcomeText: "Welcome to",
    title: "ARSH Industries",
    description:
        "We are a UAE-based manufacturer of premium tipping paper and cigarette packaging solutions—trusted by global brands for precision, consistency, and quality.",
    buttonText: "CONTACT US",
    image: heroImg,
    imageAlt: "ARSH Industry",
};